import { render, staticRenderFns } from "./VoucherVerification.vue?vue&type=template&id=3155b676&scoped=true"
import script from "./VoucherVerification.vue?vue&type=script&lang=js"
export * from "./VoucherVerification.vue?vue&type=script&lang=js"
import style0 from "./VoucherVerification.vue?vue&type=style&index=0&id=3155b676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155b676",
  null
  
)

export default component.exports